if (!customElements.get('artesta-promotion-refresh')) {
  customElements.define('artesta-promotion-refresh', class extends HTMLElement {
    connectedCallback() {
      if (this.listening) return;
      this.listening = true;
      this.resume = () => this.tick(true);
      document.addEventListener('visibilitychange', this.resume);
      window.addEventListener('pageshow', this.resume);
      window.addEventListener('online', this.resume);
      this.tick(false);
    }

    tick(refresh) {
      clearTimeout(this.timer);
      if (!this.isConnected || document.hidden) return;
      const remaining = Number(this.dataset.nextStart) * 1000 - Date.now();
      this.timer = setTimeout(() => this.tick(true), remaining > 0 ? Math.min(60000, remaining) : 60000);
      if (refresh) void this.refresh();
    }

    async refresh() {
      const section = this.closest('.shopify-section');
      // Never remount Forms or disturb a visitor filling in the modal.
      if (!section || section.querySelector('dialog[open]') || this.request || window.Shopify?.designMode) return;
      const controller = new AbortController();
      this.request = controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('_artesta_promotion_refresh', String(Date.now()));
        const response = await fetch(url, {signal: controller.signal, cache: 'no-store'});
        if (!response.ok) throw new Error('Promotion refresh failed');
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = parsed.getElementById(section.id);
        const next = nextSection?.querySelector('artesta-promotion-refresh');
        if (!next || next.dataset.sectionId !== this.dataset.sectionId
            || next.dataset.locale !== this.dataset.locale || next.dataset.country !== this.dataset.country) return;
        const promotion = nextSection.querySelector('artesta-promotion-banner');
        if (promotion) {
          const end = Number(promotion.dataset.expiresAt) * 1000;
          if (!Number.isFinite(end) || end <= Date.now()) return;
        }
        if (!this.isConnected || controller.signal.aborted || section.querySelector('dialog[open]')) return;
        const previous = section.querySelector('artesta-promotion-banner');
        if (promotion && previous) previous.replaceWith(promotion);
        else if (promotion) this.before(promotion);
        else previous?.remove();
        this.dataset.nextStart = next.dataset.nextStart;
        const subscriber = section.querySelector('artesta-subscriber-bar');
        const nextSubscriber = nextSection.querySelector('artesta-subscriber-bar');
        if (subscriber) {
          subscriber.dataset.priceState = nextSubscriber?.dataset.priceState || 'unknown';
          subscriber.sync?.();
        }
        this.tick(false);
      } catch {
        // The banner's own expiry timer still removes a stale offer offline.
      } finally {
        clearTimeout(timeout);
        if (this.request === controller) this.request = null;
      }
    }

    disconnectedCallback() {
      this.listening = false;
      clearTimeout(this.timer);
      this.request?.abort();
      document.removeEventListener('visibilitychange', this.resume);
      window.removeEventListener('pageshow', this.resume);
      window.removeEventListener('online', this.resume);
    }
  });
}
